import {
  Avatar,
  Box,
  Card,
  CardContent,
  Container,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import TelegramIcon from "@mui/icons-material/Telegram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import EdgarAvatar from "common/assets/images/contacts/edgar.jpg";
import BogdanAvatar from "common/assets/images/contacts/bogdan.jpg";

type Contact = {
  avatar: string;
  name: string;
  role: string;
  telegram: string;
  linkedin: string;
  instagram: string;
};

const contacts: Contact[] = [
  {
    avatar: BogdanAvatar,
    name: "Bogdan Lashkov",
    role: "Gründer",
    telegram: "https://t.me/b09dan",
    linkedin: "https://www.linkedin.com/in/bogdan-lashkov/",
    instagram: "https://www.instagram.com/60gdan/",
  },
  {
    avatar: EdgarAvatar,
    name: "Edgar Linde",
    role: "Gründer",
    telegram: "https://t.me/edgarlinde",
    linkedin: "https://www.linkedin.com/in/edgar-linde-a55775177/",
    instagram: "https://www.instagram.com/networkit_community/",
  },
];

function Contacts() {
  return (
    <Box component="section" sx={{ py: { xs: 8, md: 12 } }}>
      <Container maxWidth="md">
        <Typography
          component="h1"
          sx={{
            fontSize: { xs: 32, md: 48 },
            fontWeight: 900,
            lineHeight: 1.15,
            mb: { xs: 4, md: 6 },
            color: "#2c2936",
          }}
        >
          Kontakte
        </Typography>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={3}
          alignItems="stretch"
        >
          {contacts.map((c) => (
            <Card
              key={c.name}
              elevation={0}
              sx={{
                flex: 1,
                borderRadius: 3,
                border: "1px solid rgba(0,0,0,0.06)",
                background: "#fff",
                transition: "transform 200ms ease, box-shadow 200ms ease",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: "0 18px 40px -20px rgba(88,61,255,0.35)",
                },
              }}
            >
              <CardContent
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 2,
                  py: 4,
                  textAlign: "center",
                }}
              >
                <Avatar
                  src={c.avatar}
                  alt={c.name}
                  sx={{
                    width: 120,
                    height: 120,
                    border: "3px solid",
                    borderColor: "#cb97ff",
                  }}
                />
                <Box>
                  <Typography
                    component="h2"
                    sx={{
                      fontSize: 22,
                      fontWeight: 800,
                      color: "#2c2936",
                    }}
                  >
                    {c.name}
                  </Typography>
                  <Typography
                    sx={{ fontSize: 15, color: "#5d5870", mt: 0.5 }}
                  >
                    {c.role}
                  </Typography>
                </Box>
                <Stack direction="row" spacing={1}>
                  <IconButton
                    href={c.telegram}
                    target="_blank"
                    rel="noopener"
                    aria-label={`${c.name} auf Telegram`}
                    sx={{ color: "#583dff" }}
                  >
                    <TelegramIcon />
                  </IconButton>
                  <IconButton
                    href={c.linkedin}
                    target="_blank"
                    rel="noopener"
                    aria-label={`${c.name} auf LinkedIn`}
                    sx={{ color: "#583dff" }}
                  >
                    <LinkedInIcon />
                  </IconButton>
                  <IconButton
                    href={c.instagram}
                    target="_blank"
                    rel="noopener"
                    aria-label={`${c.name} auf Instagram`}
                    sx={{ color: "#583dff" }}
                  >
                    <InstagramIcon />
                  </IconButton>
                </Stack>
              </CardContent>
            </Card>
          ))}
        </Stack>
      </Container>
    </Box>
  );
}

export default Contacts;
